import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { OptionType } from 'src/app/core/enums/enums';
import { Operation } from 'src/app/core/models/operation-log.model';

import { OperationLogService } from '../../services/operation-log.service';

@Component({
  selector: 'app-operation-log',
  templateUrl: './operation-log.component.html',
})
export class OperationLogComponent implements OnInit {
  operations$: Observable<Operation[]>;
  selectedOperation: Operation;
  showModal  = false;
  optionType = OptionType;

  constructor(private service: OperationLogService) { }

  ngOnInit() {
    this.operations$ = this.service.getOperations();
  }

  openContent(operation: Operation) {
    this.selectedOperation = operation;
    this.showModal = true;
  }

}
